module.exports = __webpack_public_path__ + "static/media/TUNE_3310.fa43741d.jpg";